import { WishlistStorage } from './wishlist-storage'
import { VisiblityElement } from '../visibility/visibility'
/**
 * GM_STATE global
 */
/**
 *
 * x-storage
 *
 * Used to manage the non-logged in user's wishlist items
 * wishlist item key {{product_id}}:{{product_variant_id}}
 *
 */

export const wishlistEvent = {
  WISHLIST_ADDED: 'wishlist-added',
  WISHLIST_REMOVED: 'wishlist-removed'
}
export class StorageElement extends VisiblityElement {
  static SELECT_BUTTON = "[data-role='toggle']"
  static WISHLIST_NAVIGATION_ICON = '[data-role="icon-heart"]'
  constructor() {
    super()
    this.storage = new WishlistStorage()
    this.navigationWishlistIcons = document.querySelectorAll(StorageElement.WISHLIST_NAVIGATION_ICON)
    this.productId = this.getProductId()
    this.reRun = () => {
      this.checkIfItemExists()
    }

    this.updateItem = (item) => {
      this.dataset.product = item
    }
  }

  getProductId() {
    const product = this.dataset.product || ''
    const [id] = product.split(':')
    return id
  }

  addEventListeners() {
    this.querySelector(StorageElement.SELECT_BUTTON).addEventListener('click', this.selectedCallback.bind(this))
  }

  removeEventListeners() {
    this.querySelector(StorageElement.SELECT_BUTTON).removeEventListener('click', this.selectedCallback.bind(this))
  }

  connectedCallback() {
    this.productId = this.getProductId()
    /** Run the callback first to check if the item is in local storage */
    this.checkIfItemExists()
    /** Apply event listeners  */
    this.addEventListeners()
  }

  disconnectedCallback() {
    this.removeEventListeners()
  }

  checkIfItemExists() {
    const hasItem = this.storage.hasItem(this.dataset.product)
    hasItem ? this.handleShow() : this.handleHide()
    this.handleNavigationCallback()
  }

  handleShowItem(item) {
    this.storage.setItem(item)
    document.dispatchEvent(new CustomEvent(wishlistEvent.WISHLIST_ADDED, { detail: item }))
    this.handleShow()
  }

  handleRemoveItem(item) {
    this.storage.removeItem(item)
    document.dispatchEvent(new CustomEvent(wishlistEvent.WISHLIST_REMOVED, { detail: item }))
    this.handleHide()
  }

  /**
   * Handles both adding and removing the item if the item is present in the local storage
   * @returns
   */
  selectedCallback() {
    const hasItem = this.storage.hasItem(this.dataset.product)
    !hasItem ? this.handleShowItem(this.dataset.product) : this.handleRemoveItem(this.dataset.product)
    this.handleNavigationCallback()
  }

  hasProduct() {
    const id = this.productId
    const ids = this.storage.getProductIds()
    return ids.includes(id)
  }

  handleNavigationCallback() {
    const hasProduct = this.hasProduct()
    this.handleNavigationWishlistIconFill(hasProduct)
  }

  /**
   * If the customer is on the PDP and has the current product in their
   * wishlist fill the navigation wishlist icon red.
   */
  handleNavigationWishlistIconFill(hasItem) {
    const heartIcon = !hasItem ? '#heart' : '#heart-filled'
    this.navigationWishlistIcons.forEach((icon) => {
      const useTag = icon.querySelector('svg > use')
      useTag.setAttribute('href', heartIcon)
    })
  }
}
if (!customElements.get('x-storage')) {
  customElements.define('x-storage', StorageElement)
}
